export default __webpack_public_path__ + "static/media/image-ph-study-main-2-n-m@2x.41830541.png";